import { useState } from "react";
import Collapse from "@mui/material/Collapse";
import { makeStyles } from "@material-ui/core/styles";
import { Text } from "../../components/1elements";
import CollapseArrowIcon from "../../components/1elements/Icons/js/CollapseArrowIcon";

const CollapseContainer = ({
    contentClassName,
    header,
    dataCount,
    children,
    disabled = false
}) => {
    const classes = useStyles({disabled});
    const [toggle, setToggle] = useState(true);

    return (
        <div className={classes.root}>
            <div className={classes.collapsableHeader}>
                <CollapseArrowIcon
                    className={classes.collapsableArrow}
                    toggle={toggle}
                    setToggle={setToggle}
                    disabled={disabled}
                />
                <Text type="h2" disabled={disabled}>
                    {header} ({dataCount})
                </Text>
            </div>
            <Collapse
                className={`${classes.collapsableContent} ${contentClassName}`}
                in={toggle}
                timeout="auto"
                unmountOnExit
            >
                {children}
            </Collapse>
        </div>
    );
};

export default CollapseContainer;

const useStyles = makeStyles((theme, props) => ({
    root: {
        width: "100%",
    },
    collapsableHeader: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: "2px",
        width: "100%",
        padding: "5px",
        borderBottom: `1px solid ${theme.palette.secondary.main}`,
    },
    addButtonDiv: {
        marginBottom: "20px",
        width: "100%",
        display: "flex",
    },
    collapsableContent: {
        width: "100%",
        padding: "10px 15px",
    },
    collapsableArrow: {
        color: props => props.disabled ? theme.palette.secondary.main : theme.palette.primary.accent,
    }
}));
